// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
   Matched to: white navbar, #F0F2F5 page bg,
   #1565C0 primary blue, active-tab Pyate blue
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --brand-glow-md:  rgba(21, 101, 192, 0.28);
  --accent:         #0097A7;
  --accent-soft:    #E0F4F7;
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --surface-3:      #EBF1FB;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --danger:         #DC2626;
  --danger-soft:    #FFF0F0;
  --success:        #16A34A;
  --success-soft:   #DCFCE7;
  --like-red:       #E91E63;
  --like-soft:      #FCE4EC;
  --font:           'Plus Jakarta Sans', sans-serif;
  --font-serif:     'Lora', serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      22px;
  --radius-xl:      28px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);
  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);
  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);
}

* { box-sizing: border-box; }

body {
  background: var(--page-bg);
  font-family: var(--font);
}

/* ======================================
   PAGE WRAPPER
====================================== */
.Posts_content-edit {
  font-family: var(--font);
  max-width: 680px;
  margin: 0 auto;
  padding: 20px 16px 100px;
}

/* Page title */
.Posts_content-edit > h2 {
  font-family: var(--font);
  font-size: 22px;
  font-weight: 800;
  color: var(--brand);
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: -0.4px;
  position: relative;
}

.Posts_content-edit > h2::after {
  content: '';
  display: block;
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, var(--brand), var(--accent));
  border-radius: 100px;
  margin: 8px auto 0;
}

/* ======================================
   OLD CONTAINER — kept for fallback
====================================== */
.card-container-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 16px;
  font-family: var(--font);
  width: 100%;
  max-width: 720px;
  margin: 20px auto;
  background: transparent;
}

/* ======================================
   POST CARD
====================================== */
.card-edit {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 640px;
  margin: 0 0 18px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: box-shadow 0.26s var(--ease), transform 0.26s var(--ease), border-color 0.2s;
  position: relative;
  animation: cardIn 0.32s var(--ease) both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Blue accent stripe reveals on hover */
.card-edit::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.26s var(--ease);
  z-index: 1;
}

.card-edit:hover::before { transform: scaleX(1); }
.card-edit:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-3px);
  border-color: var(--border-strong);
}

.card-body-edit {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* ======================================
   POST HEADER
====================================== */
.Posts_header-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.logo-and-text-edit {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-image-edit {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--brand-soft);
  box-shadow: 0 0 0 2px var(--border-strong);
  flex-shrink: 0;
}

.Posts_paragraph-edit {
  text-align: left;
  font-size: 14px;
  color: var(--text-secondary);
}

.Posts_paragraph-edit p:first-child {
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1px;
  font-size: 14px;
}

.Posts_paragraph-edit p:last-child {
  font-size: 11.5px;
  margin: 0;
  color: var(--text-muted);
}

/* ======================================
   POST CONTENT & MEDIA
====================================== */
.Posts_content-edit p,
.card-body-edit .Posts_content-edit p {
  font-family: var(--font-serif);
  font-size: 14.5px;
  line-height: 1.75;
  color: var(--text-secondary);
  padding: 0 4px;
  margin-bottom: 12px;
  word-wrap: break-word;
}

.Posts_image-edit {
  width: 100%;
  max-height: 560px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  margin-bottom: 10px;
  background: var(--surface-2);
}

.uploaded-video-edit {
  width: 100%;
  max-height: 420px;
  border-radius: var(--radius-sm);
  margin-bottom: 10px;
}

/* ======================================
   DELETE / OPTIONS ROW IN HEADER
====================================== */
.delete-post-btn-edit,
.delete-btn-header-edit {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 100px;
  transition: all 0.18s var(--ease);
}

.delete-post-btn-edit:hover,
.delete-btn-header-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* More options button */
.more-btn-edit {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 18px;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s var(--ease);
}

.more-btn-edit:hover {
  background: var(--surface-3);
  color: var(--brand);
}

.more-options-edit {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Dropdown options */
.dropdown-options-edit {
  position: absolute;
  top: 38px;
  right: 0;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  box-shadow: var(--shadow-md);
  z-index: 10;
  border-radius: var(--radius-md);
  width: 180px;
  overflow: hidden;
  animation: dropIn 0.18s var(--ease);
}

@keyframes dropIn {
  from { opacity: 0; transform: translateY(-8px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.dropdown-item-edit {
  padding: 10px 14px;
  text-align: left;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  background: none;
  border: none;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.15s;
}

.dropdown-item-edit:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* Report reasons sub-panel */
.report-reasons-edit {
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  box-shadow: var(--shadow-md);
  border-radius: var(--radius-md);
  width: 200px;
  z-index: 10;
  padding: 6px 0;
  animation: dropIn 0.18s var(--ease);
}

.report-reason-item-edit {
  padding: 9px 14px;
  text-align: left;
  font-family: var(--font);
  font-size: 12.5px;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  width: 100%;
  transition: background 0.15s;
}

.report-reason-item-edit:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* Follow button */
.follow-btn-edit {
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  padding: 7px 18px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
  white-space: nowrap;
}

.follow-btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px var(--brand-glow-md);
}

/* ======================================
   POST ACTIONS (Like / Comment bar)
====================================== */
.post-actions {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
  border: 1.5px solid transparent;
}

.action-btn:hover {
  background: var(--brand-soft);
  color: var(--brand);
  border-color: var(--border-strong);
}

.action-btn.liked {
  background: var(--like-soft);
  color: var(--like-red);
  border-color: #F8BBD0;
}

.action-btn svg { font-size: 15px; }

/* Old class aliases */
.post-actions-edit {
  display: flex;
  justify-content: flex-start;
  gap: 6px;
  margin-top: 10px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.action-btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border: 1.5px solid transparent;
  background: var(--surface-2);
  color: var(--text-secondary);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.action-btn-edit:hover {
  background: var(--brand-soft);
  color: var(--brand);
  border-color: var(--border-strong);
}

.action-btn-edit.liked {
  background: var(--like-soft);
  color: var(--like-red);
}

.action-btn-edit span { margin-left: 2px; }

/* ======================================
   COMMENTS SECTION
====================================== */
.comments-section-edit {
  background: var(--surface-2);
  border-top: 1px solid var(--border);
  padding: 16px 18px;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  animation: slideDown 0.22s var(--ease);
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.comments-header-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.comments-header-edit h3 {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin: 0;
}

.close-comments-btn-edit {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.close-comments-btn-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* ======================================
   COMMENT ITEMS
====================================== */
.comments-list-edit {
  max-height: 360px;
  overflow-y: auto;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 2px;
}

.comments-list-edit::-webkit-scrollbar { width: 4px; }
.comments-list-edit::-webkit-scrollbar-track { background: transparent; }
.comments-list-edit::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 100px;
}

.comment-edit {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.comment-header-edit {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.comment-user-img-edit {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-strong);
  flex-shrink: 0;
}

.comment-user-info-edit {
  flex: 1 1;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 0 var(--radius-md) var(--radius-md) var(--radius-md);
  padding: 8px 12px;
  min-width: 0;
}

.comment-username-edit {
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-primary);
  display: block;
  margin-bottom: 2px;
}

.comment-text-edit {
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-secondary);
  line-height: 1.55;
  margin: 0;
  word-wrap: break-word;
}

.comment-options-container-edit {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

/* Delete comment button */
.comment-options-edit,
.reply-options-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 100px;
  transition: all 0.15s;
  white-space: nowrap;
}

.comment-options-edit:hover,
.reply-options-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* Hide button */
.hide-comment-btn-edit {
  font-family: var(--font);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 100px;
  transition: all 0.15s;
}

.hide-comment-btn-edit:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* ======================================
   COMMENT ACTIONS (like/reply row)
====================================== */
.comment-actions-edit {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 44px;
}

.like-btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 100px;
  transition: all 0.15s;
}

.like-btn-edit:hover { color: var(--like-red); }
.like-btn-edit.liked { color: var(--like-red); }

.reply-btn-edit,
.view-replies-btn-edit {
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 100px;
  transition: all 0.15s;
}

.reply-btn-edit:hover { color: var(--brand); }

.view-replies-btn-edit {
  color: var(--brand-mid);
  font-weight: 700;
}

.view-replies-btn-edit:hover {
  background: var(--brand-soft);
}

/* ======================================
   REPLY FORM
====================================== */
.reply-form-edit {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding-left: 44px;
}

.reply-input-edit {
  flex: 1 1;
  padding: 7px 14px;
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface);
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.reply-input-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
}

/* ======================================
   REPLIES
====================================== */
.replies-list-edit {
  padding-left: 44px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.reply-edit {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reply-header-edit {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.reply-user-img-edit {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid var(--border-strong);
  flex-shrink: 0;
}

.reply-user-info-edit {
  flex: 1 1;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 0 var(--radius-sm) var(--radius-sm) var(--radius-sm);
  padding: 6px 10px;
}

.reply-username-edit {
  font-family: var(--font);
  font-size: 12px;
  font-weight: 700;
  color: var(--text-primary);
  display: block;
  margin-bottom: 1px;
}

.reply-text-edit {
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
}

.reply-actions-edit {
  padding-left: 36px;
  display: flex;
  gap: 6px;
}

/* ======================================
   COMMENT FORM (bottom of section)
====================================== */
.comments-form-edit {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.comment-input-edit {
  flex: 1 1;
  padding: 9px 16px;
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-primary);
  background: var(--surface);
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.comment-input-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
}

.comment-input-edit::placeholder { color: var(--text-muted); }

/* Emoji button */
.emoji-btn-edit {
  width: 34px;
  height: 34px;
  background: var(--surface-2);
  border: 1.5px solid var(--border-strong);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}

.emoji-btn-edit:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}

/* Send / post button */
.submit-btn-edit {
  padding: 8px 18px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
  flex-shrink: 0;
}

.submit-btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px var(--brand-glow-md);
}

.submit-btn-edit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.send-reply-btn-edit {
  width: 34px;
  height: 34px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.18s var(--ease), box-shadow 0.18s var(--ease);
}

.send-reply-btn-edit:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 14px var(--brand-glow-md);
}

.cancel-reply-btn-edit {
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 100px;
  transition: all 0.15s;
  white-space: nowrap;
}

.cancel-reply-btn-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* ======================================
   EMOJI PICKER CONTAINER
====================================== */
.emoji-picker-container-edit {
  position: absolute;
  bottom: 48px;
  left: 0;
  z-index: 1000;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.close-emoji-picker-btn-edit {
  position: absolute;
  top: 6px;
  right: 6px;
  background: var(--surface-2);
  border: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 13px;
  cursor: pointer;
  color: var(--text-muted);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.close-emoji-picker-btn-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* ======================================
   FULL-PAGE LOADER
====================================== */
.page-loader-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
}

.page-loader-spinner-edit {
  width: 44px;
  height: 44px;
  border: 3.5px solid var(--border-strong);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: loaderSpin 0.75s linear infinite;
}

@keyframes loaderSpin {
  to { transform: rotate(360deg); }
}

.page-loader-text-edit {
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-muted);
  margin: 0;
  letter-spacing: 0.1px;
}

/* ======================================
   POSTS SECTION — wraps header + cards
====================================== */
.posts-section-edit {
  width: 100%;
  max-width: 640px;
  margin-bottom: 36px;
}

/* Sticky header sticks while its own section is scrolling */
.posts-section-header-edit {
  position: sticky;
  top: 0;
  z-index: 50;
  background: var(--page-bg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px;
  margin-bottom: 16px;
  border-bottom: 2px solid var(--border);
}

.posts-section-title-edit {
  display: flex;
  align-items: center;
  gap: 10px;
}

.posts-section-title-edit h2 {
  font-family: var(--font);
  font-size: 18px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.4px;
}

.posts-count-badge-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-soft);
  color: var(--brand);
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  border-radius: 100px;
  min-width: 24px;
  padding: 2px 8px;
  border: 1px solid var(--border-strong);
}

.posts-section-body-edit {
  display: flex;
  flex-direction: column;
}

/* ======================================
   CREATE POST BUTTON
====================================== */
.create-post-btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: #fff;
  border: none;
  border-radius: 100px;
  padding: 8px 18px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.2px;
  box-shadow: 0 2px 8px var(--brand-glow);
  cursor: pointer;
  transition: all 0.2s var(--ease);
  white-space: nowrap;
  flex-shrink: 0;
}

.create-post-btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px var(--brand-glow-md);
}

/* Floating action button — fixed, shifted left to avoid chatbot icon in bottom-right */
.floating-create-post-btn-edit {
  position: fixed;
  bottom: 32px;
  right: 100px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: #fff;
  border: none;
  border-radius: 100px;
  padding: 13px 24px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 20px var(--brand-glow-md), 0 2px 8px rgba(0,0,0,0.15);
  cursor: pointer;
  transition: all 0.22s var(--ease);
  white-space: nowrap;
  z-index: 999;
}

.floating-create-post-btn-edit:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 8px 28px var(--brand-glow-md), 0 4px 12px rgba(0,0,0,0.18);
}

.floating-create-post-btn-edit:active {
  transform: translateY(-1px) scale(0.98);
}

@media (max-width: 480px) {
  .floating-create-post-btn-edit {
    bottom: 20px;
    right: 80px;
    padding: 11px 18px;
    font-size: 13px;
  }
}

/* ======================================
   EMPTY STATE
====================================== */
.empty-state-edit {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: var(--surface);
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  margin-bottom: 8px;
}

.empty-icon-edit {
  font-size: 34px;
  margin-bottom: 12px;
  opacity: 0.55;
}

.empty-title-edit {
  font-family: var(--font);
  font-size: 14.5px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px;
}

.empty-sub-edit {
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-muted);
  margin: 0;
  text-align: center;
  line-height: 1.5;
}

/* ======================================
   SECTION ERROR
====================================== */
.section-error-edit {
  width: 100%;
  max-width: 640px;
  background: var(--danger-soft);
  border: 1px solid rgba(220,38,38,0.2);
  border-radius: var(--radius-md);
  padding: 12px 16px;
  margin-bottom: 16px;
}

.section-error-edit p {
  font-family: var(--font);
  font-size: 13px;
  color: var(--danger);
  margin: 0;
}

/* ======================================
   CREATE POST FORM — missing classes
   (.container-edit, .close-btn-edit,
    .error-message)
====================================== */
.container-edit {
  padding: 22px 24px 20px;
}

.container-edit h3 {
  font-family: var(--font);
  font-size: 15px;
  font-weight: 800;
  color: var(--brand);
  margin: 0 0 16px;
  letter-spacing: -0.2px;
  position: relative;
  padding-bottom: 10px;
}

.container-edit h3::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0;
  width: 100%;
  height: 1px;
  background: var(--border);
}

.container-edit h4 {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.9px;
  margin: 14px 0 6px;
}

.container-edit input[type="file"] {
  display: block;
  width: 100%;
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-secondary);
  background: var(--surface-2);
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.18s, background 0.15s;
}

.container-edit input[type="file"]:hover {
  border-color: var(--brand-light);
  background: var(--brand-soft);
}

.container-edit .post-actions-edit {
  border-top: 1px solid var(--border);
  padding-top: 14px;
  margin-top: 16px;
  justify-content: flex-end;
  gap: 8px;
}

.error-message {
  background: var(--danger-soft);
  color: var(--danger);
  border: 1px solid rgba(220,38,38,0.2);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 14px;
  line-height: 1.5;
}

.close-btn-edit {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
  flex-shrink: 0;
}

.close-btn-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
  border-color: rgba(220,38,38,0.3);
}

/* ======================================
   DELETE CONFIRMATION DIALOG
====================================== */
.confirmation-dialog-overlay-edit {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 40, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.confirmation-dialog-edit {
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 28px 32px;
  max-width: 380px;
  width: 90%;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  animation: modalIn 0.25s var(--ease);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.confirmation-dialog-edit::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--danger) 0%, #FF6B6B 100%);
  position: absolute;
  top: 0; left: 0; right: 0;
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(16px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.confirmation-dialog-edit h3 {
  font-family: var(--font);
  font-size: 17px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 12px 0 8px;
}

.confirmation-dialog-edit p {
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0 0 22px;
}

.confirmation-buttons-edit {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.cancel-btn-edit {
  padding: 9px 22px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.cancel-btn-edit:hover {
  background: var(--border);
  color: var(--text-primary);
}

.delete-btn-edit {
  padding: 9px 22px;
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(220,38,38,0.28);
  transition: all 0.18s var(--ease);
}

.delete-btn-edit:hover {
  background: #B91C1C;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(220,38,38,0.36);
}

/* ======================================
   MESSAGE POPUP TOAST
====================================== */
.message-popup-edit {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(12, 26, 46, 0.9);
  backdrop-filter: blur(10px);
  color: white;
  padding: 11px 22px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  animation: toastIn 0.25s var(--ease);
}

@keyframes toastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(10px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* ======================================
   UPLOAD MESSAGE
====================================== */
.upload-message {
  background: var(--brand-soft);
  color: var(--brand);
  padding: 12px 16px;
  margin-bottom: 12px;
  border-radius: var(--radius-md);
  text-align: center;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  border: 1px solid var(--border-strong);
}

/* ======================================
   CREATE POST MODAL
====================================== */
.create-post-modal-edit {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 40, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.create-post-content-edit {
  background: var(--surface);
  padding: 0;
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 580px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  animation: modalIn 0.28s var(--ease);
}

/* Tab bar */
.tabs {
  display: flex;
  border-bottom: 1.5px solid var(--border);
  padding: 0 20px;
}

.tab-btn-edit {
  flex: 1 1;
  background: none;
  border: none;
  padding: 13px 10px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-muted);
  border-bottom: 2.5px solid transparent;
  margin-bottom: -1.5px;
  transition: color 0.18s, border-color 0.18s;
}

.tab-btn-edit.active {
  border-bottom-color: var(--brand);
  color: var(--brand);
}

.tab-content-edit { padding: 16px 20px; }

.post-input-edit {
  width: 100%;
  padding: 12px 14px;
  font-family: var(--font);
  font-size: 14px;
  color: var(--text-primary);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  outline: none;
  resize: vertical;
  min-height: 110px;
  transition: border-color 0.18s, box-shadow 0.18s;
  background: var(--surface-2);
}

.post-input-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background: white;
}

.image-tab-edit,
.video-tab-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.preview-image,
.preview-video {
  max-width: 100%;
  max-height: 240px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 768px) {
  .Posts_content-edit { padding: 12px 10px 90px; }
  .card-edit { border-radius: var(--radius-md); }
  .card-body-edit { padding: 12px 14px; }
  .logo-image-edit { width: 36px; height: 36px; }
  .floating-create-post-btn-edit { padding: 11px 20px; font-size: 13px; }
  .create-post-btn-edit          { padding: 7px 14px; font-size: 12px; }
  .comment-user-img-edit { width: 30px; height: 30px; }
  .comments-list-edit { max-height: 280px; }
  .reply-form-edit { padding-left: 36px; }
  .comment-actions-edit { padding-left: 36px; }
  .replies-list-edit { padding-left: 36px; }
}

@media (max-width: 480px) {
  .Posts_content-edit { padding: 10px 8px 80px; }
  .card-body-edit { padding: 10px 12px; }
  /* floating btn handled in its own block above */
  .action-btn, .action-btn-edit { padding: 6px 12px; font-size: 12px; }
  .confirmation-dialog-edit { padding: 22px 20px; }
}
/* ======================================
   CREATE POST MODAL — BEAUTIFIED
====================================== */
.create-post-modal-edit {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 40, 0.50);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.create-post-content-edit {
  background: var(--surface);
  padding: 0;
  border-radius: var(--radius-lg);
  width: 92%;
  max-width: 540px;
  max-height: 82vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  animation: modalIn 0.28s var(--ease);
}

/* Modal header row */
.modal-header-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 0;
}

.modal-title-edit {
  font-family: var(--font);
  font-size: 15px;
  font-weight: 800;
  color: var(--brand);
  letter-spacing: -0.2px;
}

.modal-close-edit {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: var(--surface-2);
  color: var(--text-muted);
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s var(--ease);
}

.modal-close-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* Tab bar */
.tabs {
  display: flex;
  border-bottom: 1.5px solid var(--border);
  padding: 0 18px;
  margin-top: 10px;
}

.tab-btn-edit {
  flex: 1 1;
  background: none;
  border: none;
  padding: 9px 8px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-muted);
  border-bottom: 2.5px solid transparent;
  margin-bottom: -1.5px;
  transition: color 0.18s, border-color 0.18s;
}

.tab-btn-edit.active {
  border-bottom-color: var(--brand);
  color: var(--brand);
}

/* Tab body — reduced padding */
.tab-content-edit {
  padding: 14px 18px 16px;
}

/* Author row inside modal */
.post-author-row-edit {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.post-author-avatar-edit {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-strong);
  flex-shrink: 0;
}

.post-author-name-edit {
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1px;
}

.post-author-scope-edit {
  font-family: var(--font);
  font-size: 11px;
  color: var(--text-muted);
  margin: 0;
}

/* Main textarea */
.post-input-edit {
  width: 100%;
  padding: 10px 12px;
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-primary);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  outline: none;
  resize: none;
  min-height: 90px;
  max-height: 220px;
  line-height: 1.65;
  background: var(--surface-2);
  box-sizing: border-box;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.post-input-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background: var(--surface);
}

.post-input-edit::placeholder {
  color: var(--text-muted);
}

/* Char counter */
.post-char-count-edit {
  text-align: right;
  font-family: var(--font);
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 4px;
  margin-bottom: 0;
}

/* Media attachment strip */
.post-media-strip-edit {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  padding: 8px;
  background: var(--surface-2);
  border-radius: var(--radius-sm);
  border: 1.5px dashed var(--border-strong);
}

.media-strip-btn-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  flex: 1 1;
  padding: 7px 4px;
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  color: var(--text-muted);
  font-family: var(--font);
  font-size: 10.5px;
  font-weight: 600;
  transition: background 0.15s, color 0.15s;
}

.media-strip-btn-edit svg,
.media-strip-btn-edit span.icon {
  font-size: 16px;
}

.media-strip-btn-edit:hover {
  background: var(--brand-soft);
  color: var(--brand);
}

/* Preview images / videos */
.preview-image {
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  margin-top: 8px;
}

.preview-video {
  width: 100%;
  max-height: 200px;
  border-radius: var(--radius-sm);
  margin-top: 8px;
}

/* Upload zone (image/video tabs) */
.upload-zone-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 16px;
  background: var(--surface-2);
  border: 2px dashed var(--border-strong);
  border-radius: var(--radius-md);
  cursor: pointer;
  color: var(--text-muted);
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s, border-color 0.15s;
}

.upload-zone-edit:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}

.upload-zone-edit .upload-icon {
  font-size: 28px;
  opacity: 0.7;
}

/* Divider */
.modal-divider-edit {
  height: 1px;
  background: var(--border);
  margin: 12px 0;
}

/* Footer row */
.modal-footer-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

/* Emoji / quick tool buttons */
.quick-tools-edit {
  display: flex;
  gap: 4px;
}

.quick-tool-btn-edit {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid var(--border-strong);
  background: var(--surface-2);
  color: var(--text-muted);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s var(--ease);
}

.quick-tool-btn-edit:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}

/* Post submit button */
.submit-btn-edit {
  padding: 9px 24px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.2px;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
  flex-shrink: 0;
}

.submit-btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px var(--brand-glow-md);
}

.submit-btn-edit:disabled {
  opacity: 0.42;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Image / video tab layout */
.image-tab-edit,
.video-tab-edit {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Upload message */
.upload-message {
  background: var(--brand-soft);
  color: var(--brand);
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  text-align: center;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  border: 1px solid var(--border-strong);
  margin-bottom: 8px;
}

/* Emoji picker */
.emoji-picker-container-edit {
  position: absolute;
  bottom: 44px;
  left: 0;
  z-index: 1000;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.close-emoji-picker-btn-edit {
  position: absolute;
  top: 5px;
  right: 5px;
  background: var(--surface-2);
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;
  color: var(--text-muted);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.close-emoji-picker-btn-edit:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

/* Responsive */
@media (max-width: 480px) {
  .create-post-content-edit {
    width: 96%;
    border-radius: var(--radius-md);
  }
  .tab-content-edit {
    padding: 12px 14px 14px;
  }
  .modal-header-edit {
    padding: 12px 14px 0;
  }
  .tabs {
    padding: 0 14px;
  }
  .post-input-edit {
    font-size: 13px;
    min-height: 80px;
  }
  .submit-btn-edit {
    padding: 8px 18px;
    font-size: 12.5px;
  }
}
/* ======================================
   SKELETON LOADING CARDS
====================================== */
.skeleton {
  background: linear-gradient(90deg, #e8edf5 25%, #f4f6fa 50%, #e8edf5 75%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
  border-radius: var(--radius-sm);
}

@keyframes shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.skeleton-card {
  pointer-events: none;
  opacity: 0.85;
}

.skeleton-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-line {
  height: 13px;
  display: block;
}

.skeleton-media {
  width: 100%;
  height: 200px;
  border-radius: var(--radius-md);
  margin-top: 14px;
}

/* ======================================
   OWN POST BADGE
====================================== */
.own-post-card {
  border-color: var(--brand-soft);
  background: linear-gradient(180deg, #fafcff 0%, var(--surface) 100%);
}

.own-post-badge {
  font-family: var(--font);
  font-size: 10.5px;
  font-weight: 700;
  color: var(--brand);
  background: var(--brand-soft);
  text-align: center;
  padding: 4px 10px;
  border-bottom: 1px solid var(--border);
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

/* ======================================
   POST META ROW (date + like count)
====================================== */
.post-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 4px 0;
  margin-bottom: 2px;
}

.meta-likes {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
}

.meta-time {
  font-family: var(--font);
  font-size: 11.5px;
  color: var(--text-muted);
}

/* ======================================
   HEADER RIGHT (follow + options)
====================================== */
.header-right-edit {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Following state for follow button */
.follow-btn-edit.following {
  background: transparent;
  color: var(--brand);
  border: 1.5px solid var(--brand-mid);
  box-shadow: none;
}

.follow-btn-edit.following:hover {
  background: var(--brand-soft);
  transform: none;
  box-shadow: none;
}

/* ======================================
   ERROR & EMPTY STATES
====================================== */
.error-state-edit {
  text-align: center;
  padding: 48px 24px;
  color: var(--danger);
  font-family: var(--font);
}

.retry-btn-edit {
  margin-top: 14px;
  padding: 9px 28px;
  background: linear-gradient(135deg, var(--brand), var(--brand-mid));
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease);
}
.retry-btn-edit:hover { transform: translateY(-2px); }

.empty-state-edit {
  text-align: center;
  padding: 56px 24px;
  color: var(--text-muted);
  font-family: var(--font);
  font-size: 14px;
}

/* ======================================
   NO COMMENTS TEXT
====================================== */
.no-comments-text {
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
  padding: 12px 0;
  margin: 0;
}

/* ======================================
   FLOATING CREATE POST BUTTON — Enhanced
====================================== */
.floating-create-post-btn-edit {
  position: fixed;
  bottom: 28px;
  right: 28px;
  padding: 13px 26px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 20px var(--brand-glow-md), 0 2px 6px rgba(0,0,0,0.15);
  letter-spacing: 0.3px;
  transition: transform 0.22s var(--ease), box-shadow 0.22s var(--ease);
  z-index: 200;
}

.floating-create-post-btn-edit:hover {
  transform: translateY(-3px) scale(1.04);
  box-shadow: 0 8px 28px var(--brand-glow-md);
}

/* ======================================
   MESSAGE POPUP — enhanced
====================================== */
.message-popup-edit {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--text-primary);
  color: white;
  padding: 10px 22px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
  animation: popIn 0.22s var(--ease);
}

@keyframes popIn {
  from { opacity: 0; transform: translateX(-50%) translateY(10px) scale(0.95); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
}

/* ======================================
   HIDE REPLY BUTTON
====================================== */
.hide-reply-btn-edit {
  font-family: var(--font);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 100px;
  transition: all 0.15s;
}

.hide-reply-btn-edit:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* Reply options container */
.reply-options-container-edit {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

/* ======================================
   FEED ROOT — two-section layout
====================================== */
.feed-root {
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 24px 16px 120px;
  font-family: var(--font);
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ======================================
   FEED SECTION (wrapper for each group)
====================================== */
.feed-section {
  margin-bottom: 40px;
}

.feed-section--suggested {
  position: relative;
}

/* Divider line between the two sections */
.feed-section--suggested::before {
  content: '';
  display: block;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-strong) 30%, var(--border-strong) 70%, transparent);
  margin-bottom: 32px;
}

/* ======================================
   SECTION HEADER (title + action row)
====================================== */
.feed-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 2.5px solid var(--border);
  position: relative;
}

/* left-side accent line on the active section */
.feed-section-header::after {
  content: '';
  position: absolute;
  bottom: -2.5px;
  left: 0;
  width: 48px;
  height: 2.5px;
  background: linear-gradient(90deg, var(--brand), var(--brand-light));
  border-radius: 100px;
}

.feed-section-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feed-section-icon {
  font-size: 22px;
  line-height: 1;
  flex-shrink: 0;
}

.feed-section-title {
  font-family: var(--font);
  font-size: 18px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 2px;
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.feed-section-sub {
  font-family: var(--font);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   INLINE CREATE-POST BUTTON
   (sits in the My Posts header row)
====================================== */
.create-post-inline-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 20px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: #fff;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.2px;
  box-shadow: 0 2px 10px var(--brand-glow);
  white-space: nowrap;
  flex-shrink: 0;
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.create-post-inline-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.create-post-plus {
  font-size: 18px;
  line-height: 1;
  font-weight: 400;
}

/* ======================================
   POST LIST — stacked with gap
====================================== */
.post-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-feed {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ======================================
   EMPTY STATE — updated with icon
====================================== */
.empty-state-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 24px;
  background: var(--surface-2);
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  text-align: center;
}

.empty-icon {
  font-size: 36px;
  line-height: 1;
}

.empty-state-edit p {
  font-family: var(--font);
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   OWN POST: remove old badge, keep subtle tint
====================================== */
.own-post-card {
  border-left: 3px solid var(--brand-light);
}

/* Remove the text badge — section heading already communicates ownership */
.own-post-badge {
  display: none;
}

/* ======================================
   FLOATING CREATE BUTTON — hide since
   we now have the inline button.
   Keep definition in case it's reused.
====================================== */
.floating-create-post-btn-edit {
  display: none;
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 520px) {
  .feed-root {
    padding: 16px 10px 100px;
  }

  .feed-section-title {
    font-size: 16px;
  }

  .create-post-inline-btn {
    padding: 8px 14px;
    font-size: 12px;
  }

  .create-post-plus {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EditPosts.css"],"names":[],"mappings":"AAEA;;;;wCAIwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,gFAAgF;EAChF,iDAAiD;AACnD;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,+DAA+D;EAC/D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wFAAwF;EACxF,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,+FAA+F;EAC/F,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;EACvC,UAAU;AACZ;;AAEA,2BAA2B,oBAAoB,EAAE;AACjD;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;;EAEE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,mEAAmE;EACnE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,kBAAkB,eAAe,EAAE;;AAEnC,sBAAsB;AACtB;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,wBAAwB,gBAAgB,EAAE;;AAE1C;;wCAEwC;AACxC;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;EAClB,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,yCAAyC,UAAU,EAAE;AACrD,+CAA+C,uBAAuB,EAAE;AACxE;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,mEAAmE;EACnE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,uBAAuB,sBAAsB,EAAE;AAC/C,uBAAuB,sBAAsB,EAAE;;AAE/C;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,mEAAmE;EACnE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,mCAAmC,wBAAwB,EAAE;;AAE7D,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,mEAAmE;EACnE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,qEAAqE;AACvE;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,qBAAqB;AACvB;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;EACvC,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,uFAAuF;AACvF;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uEAAuE;EACvE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,wEAAwE;AAC1E;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,SAAS;AACX;;AAEA;;;;wCAIwC;AACxC;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,OAAO;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,4BAA4B;EAC5B,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,kEAAkE;EAClE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;EACjE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;;wCAEwC;AACxC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,sCAAsC;EACtC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,oBAAoB,kBAAkB,EAAE;;AAExC;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;wCAEwC;AACxC;EACE,sBAAsB,uBAAuB,EAAE;EAC/C,aAAa,+BAA+B,EAAE;EAC9C,kBAAkB,kBAAkB,EAAE;EACtC,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,iCAAiC,kBAAkB,EAAE,eAAe,EAAE;EACtE,iCAAiC,iBAAiB,EAAE,eAAe,EAAE;EACrE,yBAAyB,WAAW,EAAE,YAAY,EAAE;EACpD,sBAAsB,iBAAiB,EAAE;EACzC,mBAAmB,kBAAkB,EAAE;EACvC,wBAAwB,kBAAkB,EAAE;EAC5C,qBAAqB,kBAAkB,EAAE;AAC3C;;AAEA;EACE,sBAAsB,sBAAsB,EAAE;EAC9C,kBAAkB,kBAAkB,EAAE;EACtC,gDAAgD;EAChD,gCAAgC,iBAAiB,EAAE,eAAe,EAAE;EACpE,4BAA4B,kBAAkB,EAAE;AAClD;AACA;;wCAEwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,sCAAsC;EACtC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;EACvC,mEAAmE;EACnE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;;wCAEwC;AACxC;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,+BAA+B;EAC/B,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;AACA,wBAAwB,2BAA2B,EAAE;;AAErD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uEAAuE;EACvE,qBAAqB;EACrB,qEAAqE;EACrE,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,wDAAwD,EAAE;EAC7E,OAAO,UAAU,EAAE,kDAAkD,EAAE;AACzE;;AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,gHAAgH;EAChH,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,WAAW;EACX,aAAa;EACb,oEAAoE;EACpE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;;;wCAGwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,yCAAyC;AAC3C;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA;;;;wCAIwC;AACxC;EACE,aAAa;AACf;;AAEA;;wCAEwC;AACxC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n   Matched to: white navbar, #F0F2F5 page bg,\n   #1565C0 primary blue, active-tab Pyate blue\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --brand-glow-md:  rgba(21, 101, 192, 0.28);\n  --accent:         #0097A7;\n  --accent-soft:    #E0F4F7;\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --surface-3:      #EBF1FB;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --danger:         #DC2626;\n  --danger-soft:    #FFF0F0;\n  --success:        #16A34A;\n  --success-soft:   #DCFCE7;\n  --like-red:       #E91E63;\n  --like-soft:      #FCE4EC;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --font-serif:     'Lora', serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      22px;\n  --radius-xl:      28px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);\n  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);\n  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);\n}\n\n* { box-sizing: border-box; }\n\nbody {\n  background: var(--page-bg);\n  font-family: var(--font);\n}\n\n/* ======================================\n   PAGE WRAPPER\n====================================== */\n.Posts_content-edit {\n  font-family: var(--font);\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 20px 16px 100px;\n}\n\n/* Page title */\n.Posts_content-edit > h2 {\n  font-family: var(--font);\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--brand);\n  text-align: center;\n  margin-bottom: 24px;\n  letter-spacing: -0.4px;\n  position: relative;\n}\n\n.Posts_content-edit > h2::after {\n  content: '';\n  display: block;\n  width: 40px;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand), var(--accent));\n  border-radius: 100px;\n  margin: 8px auto 0;\n}\n\n/* ======================================\n   OLD CONTAINER — kept for fallback\n====================================== */\n.card-container-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 16px;\n  font-family: var(--font);\n  width: 100%;\n  max-width: 720px;\n  margin: 20px auto;\n  background: transparent;\n}\n\n/* ======================================\n   POST CARD\n====================================== */\n.card-edit {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 640px;\n  margin: 0 0 18px;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: box-shadow 0.26s var(--ease), transform 0.26s var(--ease), border-color 0.2s;\n  position: relative;\n  animation: cardIn 0.32s var(--ease) both;\n}\n\n@keyframes cardIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Blue accent stripe reveals on hover */\n.card-edit::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.26s var(--ease);\n  z-index: 1;\n}\n\n.card-edit:hover::before { transform: scaleX(1); }\n.card-edit:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-3px);\n  border-color: var(--border-strong);\n}\n\n.card-body-edit {\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* ======================================\n   POST HEADER\n====================================== */\n.Posts_header-edit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n.logo-and-text-edit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.logo-image-edit {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--brand-soft);\n  box-shadow: 0 0 0 2px var(--border-strong);\n  flex-shrink: 0;\n}\n\n.Posts_paragraph-edit {\n  text-align: left;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.Posts_paragraph-edit p:first-child {\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 1px;\n  font-size: 14px;\n}\n\n.Posts_paragraph-edit p:last-child {\n  font-size: 11.5px;\n  margin: 0;\n  color: var(--text-muted);\n}\n\n/* ======================================\n   POST CONTENT & MEDIA\n====================================== */\n.Posts_content-edit p,\n.card-body-edit .Posts_content-edit p {\n  font-family: var(--font-serif);\n  font-size: 14.5px;\n  line-height: 1.75;\n  color: var(--text-secondary);\n  padding: 0 4px;\n  margin-bottom: 12px;\n  word-wrap: break-word;\n}\n\n.Posts_image-edit {\n  width: 100%;\n  max-height: 560px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  margin-bottom: 10px;\n  background: var(--surface-2);\n}\n\n.uploaded-video-edit {\n  width: 100%;\n  max-height: 420px;\n  border-radius: var(--radius-sm);\n  margin-bottom: 10px;\n}\n\n/* ======================================\n   DELETE / OPTIONS ROW IN HEADER\n====================================== */\n.delete-post-btn-edit,\n.delete-btn-header-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 100px;\n  transition: all 0.18s var(--ease);\n}\n\n.delete-post-btn-edit:hover,\n.delete-btn-header-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* More options button */\n.more-btn-edit {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 18px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 50%;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.18s var(--ease);\n}\n\n.more-btn-edit:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n.more-options-edit {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Dropdown options */\n.dropdown-options-edit {\n  position: absolute;\n  top: 38px;\n  right: 0;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  box-shadow: var(--shadow-md);\n  z-index: 10;\n  border-radius: var(--radius-md);\n  width: 180px;\n  overflow: hidden;\n  animation: dropIn 0.18s var(--ease);\n}\n\n@keyframes dropIn {\n  from { opacity: 0; transform: translateY(-8px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.dropdown-item-edit {\n  padding: 10px 14px;\n  text-align: left;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  width: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.15s;\n}\n\n.dropdown-item-edit:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* Report reasons sub-panel */\n.report-reasons-edit {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  box-shadow: var(--shadow-md);\n  border-radius: var(--radius-md);\n  width: 200px;\n  z-index: 10;\n  padding: 6px 0;\n  animation: dropIn 0.18s var(--ease);\n}\n\n.report-reason-item-edit {\n  padding: 9px 14px;\n  text-align: left;\n  font-family: var(--font);\n  font-size: 12.5px;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  transition: background 0.15s;\n}\n\n.report-reason-item-edit:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* Follow button */\n.follow-btn-edit {\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  padding: 7px 18px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n  white-space: nowrap;\n}\n\n.follow-btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px var(--brand-glow-md);\n}\n\n/* ======================================\n   POST ACTIONS (Like / Comment bar)\n====================================== */\n.post-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 10px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n  border: 1.5px solid transparent;\n}\n\n.action-btn:hover {\n  background: var(--brand-soft);\n  color: var(--brand);\n  border-color: var(--border-strong);\n}\n\n.action-btn.liked {\n  background: var(--like-soft);\n  color: var(--like-red);\n  border-color: #F8BBD0;\n}\n\n.action-btn svg { font-size: 15px; }\n\n/* Old class aliases */\n.post-actions-edit {\n  display: flex;\n  justify-content: flex-start;\n  gap: 6px;\n  margin-top: 10px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n}\n\n.action-btn-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  border: 1.5px solid transparent;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.action-btn-edit:hover {\n  background: var(--brand-soft);\n  color: var(--brand);\n  border-color: var(--border-strong);\n}\n\n.action-btn-edit.liked {\n  background: var(--like-soft);\n  color: var(--like-red);\n}\n\n.action-btn-edit span { margin-left: 2px; }\n\n/* ======================================\n   COMMENTS SECTION\n====================================== */\n.comments-section-edit {\n  background: var(--surface-2);\n  border-top: 1px solid var(--border);\n  padding: 16px 18px;\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n  animation: slideDown 0.22s var(--ease);\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.comments-header-edit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.comments-header-edit h3 {\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  margin: 0;\n}\n\n.close-comments-btn-edit {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.close-comments-btn-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* ======================================\n   COMMENT ITEMS\n====================================== */\n.comments-list-edit {\n  max-height: 360px;\n  overflow-y: auto;\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 2px;\n}\n\n.comments-list-edit::-webkit-scrollbar { width: 4px; }\n.comments-list-edit::-webkit-scrollbar-track { background: transparent; }\n.comments-list-edit::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: 100px;\n}\n\n.comment-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.comment-header-edit {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.comment-user-img-edit {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border-strong);\n  flex-shrink: 0;\n}\n\n.comment-user-info-edit {\n  flex: 1;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 0 var(--radius-md) var(--radius-md) var(--radius-md);\n  padding: 8px 12px;\n  min-width: 0;\n}\n\n.comment-username-edit {\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: block;\n  margin-bottom: 2px;\n}\n\n.comment-text-edit {\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-secondary);\n  line-height: 1.55;\n  margin: 0;\n  word-wrap: break-word;\n}\n\n.comment-options-container-edit {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* Delete comment button */\n.comment-options-edit,\n.reply-options-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: var(--font);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.comment-options-edit:hover,\n.reply-options-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* Hide button */\n.hide-comment-btn-edit {\n  font-family: var(--font);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n}\n\n.hide-comment-btn-edit:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* ======================================\n   COMMENT ACTIONS (like/reply row)\n====================================== */\n.comment-actions-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-left: 44px;\n}\n\n.like-btn-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n}\n\n.like-btn-edit:hover { color: var(--like-red); }\n.like-btn-edit.liked { color: var(--like-red); }\n\n.reply-btn-edit,\n.view-replies-btn-edit {\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n}\n\n.reply-btn-edit:hover { color: var(--brand); }\n\n.view-replies-btn-edit {\n  color: var(--brand-mid);\n  font-weight: 700;\n}\n\n.view-replies-btn-edit:hover {\n  background: var(--brand-soft);\n}\n\n/* ======================================\n   REPLY FORM\n====================================== */\n.reply-form-edit {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding-left: 44px;\n}\n\n.reply-input-edit {\n  flex: 1;\n  padding: 7px 14px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-primary);\n  background: var(--surface);\n  outline: none;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n\n.reply-input-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n}\n\n/* ======================================\n   REPLIES\n====================================== */\n.replies-list-edit {\n  padding-left: 44px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.reply-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.reply-header-edit {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.reply-user-img-edit {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.5px solid var(--border-strong);\n  flex-shrink: 0;\n}\n\n.reply-user-info-edit {\n  flex: 1;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) var(--radius-sm);\n  padding: 6px 10px;\n}\n\n.reply-username-edit {\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: block;\n  margin-bottom: 1px;\n}\n\n.reply-text-edit {\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin: 0;\n}\n\n.reply-actions-edit {\n  padding-left: 36px;\n  display: flex;\n  gap: 6px;\n}\n\n/* ======================================\n   COMMENT FORM (bottom of section)\n====================================== */\n.comments-form-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n}\n\n.comment-input-edit {\n  flex: 1;\n  padding: 9px 16px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-primary);\n  background: var(--surface);\n  outline: none;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n\n.comment-input-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n}\n\n.comment-input-edit::placeholder { color: var(--text-muted); }\n\n/* Emoji button */\n.emoji-btn-edit {\n  width: 34px;\n  height: 34px;\n  background: var(--surface-2);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  font-size: 16px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.15s;\n}\n\n.emoji-btn-edit:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}\n\n/* Send / post button */\n.submit-btn-edit {\n  padding: 8px 18px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n  flex-shrink: 0;\n}\n\n.submit-btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px var(--brand-glow-md);\n}\n\n.submit-btn-edit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.send-reply-btn-edit {\n  width: 34px;\n  height: 34px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.18s var(--ease), box-shadow 0.18s var(--ease);\n}\n\n.send-reply-btn-edit:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 14px var(--brand-glow-md);\n}\n\n.cancel-reply-btn-edit {\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.cancel-reply-btn-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* ======================================\n   EMOJI PICKER CONTAINER\n====================================== */\n.emoji-picker-container-edit {\n  position: absolute;\n  bottom: 48px;\n  left: 0;\n  z-index: 1000;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.close-emoji-picker-btn-edit {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  background: var(--surface-2);\n  border: none;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  font-size: 13px;\n  cursor: pointer;\n  color: var(--text-muted);\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.close-emoji-picker-btn-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* ======================================\n   FULL-PAGE LOADER\n====================================== */\n.page-loader-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  gap: 16px;\n}\n\n.page-loader-spinner-edit {\n  width: 44px;\n  height: 44px;\n  border: 3.5px solid var(--border-strong);\n  border-top-color: var(--brand);\n  border-radius: 50%;\n  animation: loaderSpin 0.75s linear infinite;\n}\n\n@keyframes loaderSpin {\n  to { transform: rotate(360deg); }\n}\n\n.page-loader-text-edit {\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin: 0;\n  letter-spacing: 0.1px;\n}\n\n/* ======================================\n   POSTS SECTION — wraps header + cards\n====================================== */\n.posts-section-edit {\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: 36px;\n}\n\n/* Sticky header sticks while its own section is scrolling */\n.posts-section-header-edit {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: var(--page-bg);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0 12px;\n  margin-bottom: 16px;\n  border-bottom: 2px solid var(--border);\n}\n\n.posts-section-title-edit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.posts-section-title-edit h2 {\n  font-family: var(--font);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.4px;\n}\n\n.posts-count-badge-edit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--brand-soft);\n  color: var(--brand);\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 100px;\n  min-width: 24px;\n  padding: 2px 8px;\n  border: 1px solid var(--border-strong);\n}\n\n.posts-section-body-edit {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ======================================\n   CREATE POST BUTTON\n====================================== */\n.create-post-btn-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  padding: 8px 18px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  cursor: pointer;\n  transition: all 0.2s var(--ease);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.create-post-btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px var(--brand-glow-md);\n}\n\n/* Floating action button — fixed, shifted left to avoid chatbot icon in bottom-right */\n.floating-create-post-btn-edit {\n  position: fixed;\n  bottom: 32px;\n  right: 100px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  padding: 13px 24px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  box-shadow: 0 4px 20px var(--brand-glow-md), 0 2px 8px rgba(0,0,0,0.15);\n  cursor: pointer;\n  transition: all 0.22s var(--ease);\n  white-space: nowrap;\n  z-index: 999;\n}\n\n.floating-create-post-btn-edit:hover {\n  transform: translateY(-3px) scale(1.03);\n  box-shadow: 0 8px 28px var(--brand-glow-md), 0 4px 12px rgba(0,0,0,0.18);\n}\n\n.floating-create-post-btn-edit:active {\n  transform: translateY(-1px) scale(0.98);\n}\n\n@media (max-width: 480px) {\n  .floating-create-post-btn-edit {\n    bottom: 20px;\n    right: 80px;\n    padding: 11px 18px;\n    font-size: 13px;\n  }\n}\n\n/* ======================================\n   EMPTY STATE\n====================================== */\n.empty-state-edit {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  background: var(--surface);\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--radius-lg);\n  margin-bottom: 8px;\n}\n\n.empty-icon-edit {\n  font-size: 34px;\n  margin-bottom: 12px;\n  opacity: 0.55;\n}\n\n.empty-title-edit {\n  font-family: var(--font);\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n}\n\n.empty-sub-edit {\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-muted);\n  margin: 0;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* ======================================\n   SECTION ERROR\n====================================== */\n.section-error-edit {\n  width: 100%;\n  max-width: 640px;\n  background: var(--danger-soft);\n  border: 1px solid rgba(220,38,38,0.2);\n  border-radius: var(--radius-md);\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.section-error-edit p {\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--danger);\n  margin: 0;\n}\n\n/* ======================================\n   CREATE POST FORM — missing classes\n   (.container-edit, .close-btn-edit,\n    .error-message)\n====================================== */\n.container-edit {\n  padding: 22px 24px 20px;\n}\n\n.container-edit h3 {\n  font-family: var(--font);\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0 0 16px;\n  letter-spacing: -0.2px;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.container-edit h3::after {\n  content: '';\n  position: absolute;\n  bottom: 0; left: 0;\n  width: 100%;\n  height: 1px;\n  background: var(--border);\n}\n\n.container-edit h4 {\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  margin: 14px 0 6px;\n}\n\n.container-edit input[type=\"file\"] {\n  display: block;\n  width: 100%;\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-secondary);\n  background: var(--surface-2);\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--radius-sm);\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: border-color 0.18s, background 0.15s;\n}\n\n.container-edit input[type=\"file\"]:hover {\n  border-color: var(--brand-light);\n  background: var(--brand-soft);\n}\n\n.container-edit .post-actions-edit {\n  border-top: 1px solid var(--border);\n  padding-top: 14px;\n  margin-top: 16px;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.error-message {\n  background: var(--danger-soft);\n  color: var(--danger);\n  border: 1px solid rgba(220,38,38,0.2);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 14px;\n  line-height: 1.5;\n}\n\n.close-btn-edit {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 20px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n  flex-shrink: 0;\n}\n\n.close-btn-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n  border-color: rgba(220,38,38,0.3);\n}\n\n/* ======================================\n   DELETE CONFIRMATION DIALOG\n====================================== */\n.confirmation-dialog-overlay-edit {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 20, 40, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.confirmation-dialog-edit {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 28px 32px;\n  max-width: 380px;\n  width: 90%;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  animation: modalIn 0.25s var(--ease);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.confirmation-dialog-edit::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--danger) 0%, #FF6B6B 100%);\n  position: absolute;\n  top: 0; left: 0; right: 0;\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(16px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.confirmation-dialog-edit h3 {\n  font-family: var(--font);\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 12px 0 8px;\n}\n\n.confirmation-dialog-edit p {\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0 0 22px;\n}\n\n.confirmation-buttons-edit {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.cancel-btn-edit {\n  padding: 9px 22px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.cancel-btn-edit:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n.delete-btn-edit {\n  padding: 9px 22px;\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(220,38,38,0.28);\n  transition: all 0.18s var(--ease);\n}\n\n.delete-btn-edit:hover {\n  background: #B91C1C;\n  transform: translateY(-1px);\n  box-shadow: 0 5px 16px rgba(220,38,38,0.36);\n}\n\n/* ======================================\n   MESSAGE POPUP TOAST\n====================================== */\n.message-popup-edit {\n  position: fixed;\n  bottom: 28px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(12, 26, 46, 0.9);\n  backdrop-filter: blur(10px);\n  color: white;\n  padding: 11px 22px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  z-index: 1000;\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  animation: toastIn 0.25s var(--ease);\n}\n\n@keyframes toastIn {\n  from { opacity: 0; transform: translateX(-50%) translateY(10px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n/* ======================================\n   UPLOAD MESSAGE\n====================================== */\n.upload-message {\n  background: var(--brand-soft);\n  color: var(--brand);\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  border-radius: var(--radius-md);\n  text-align: center;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid var(--border-strong);\n}\n\n/* ======================================\n   CREATE POST MODAL\n====================================== */\n.create-post-modal-edit {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 20, 40, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.create-post-content-edit {\n  background: var(--surface);\n  padding: 0;\n  border-radius: var(--radius-lg);\n  width: 90%;\n  max-width: 580px;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  animation: modalIn 0.28s var(--ease);\n}\n\n/* Tab bar */\n.tabs {\n  display: flex;\n  border-bottom: 1.5px solid var(--border);\n  padding: 0 20px;\n}\n\n.tab-btn-edit {\n  flex: 1;\n  background: none;\n  border: none;\n  padding: 13px 10px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--text-muted);\n  border-bottom: 2.5px solid transparent;\n  margin-bottom: -1.5px;\n  transition: color 0.18s, border-color 0.18s;\n}\n\n.tab-btn-edit.active {\n  border-bottom-color: var(--brand);\n  color: var(--brand);\n}\n\n.tab-content-edit { padding: 16px 20px; }\n\n.post-input-edit {\n  width: 100%;\n  padding: 12px 14px;\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--text-primary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  outline: none;\n  resize: vertical;\n  min-height: 110px;\n  transition: border-color 0.18s, box-shadow 0.18s;\n  background: var(--surface-2);\n}\n\n.post-input-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background: white;\n}\n\n.image-tab-edit,\n.video-tab-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.preview-image,\n.preview-video {\n  max-width: 100%;\n  max-height: 240px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 768px) {\n  .Posts_content-edit { padding: 12px 10px 90px; }\n  .card-edit { border-radius: var(--radius-md); }\n  .card-body-edit { padding: 12px 14px; }\n  .logo-image-edit { width: 36px; height: 36px; }\n  .floating-create-post-btn-edit { padding: 11px 20px; font-size: 13px; }\n  .create-post-btn-edit          { padding: 7px 14px; font-size: 12px; }\n  .comment-user-img-edit { width: 30px; height: 30px; }\n  .comments-list-edit { max-height: 280px; }\n  .reply-form-edit { padding-left: 36px; }\n  .comment-actions-edit { padding-left: 36px; }\n  .replies-list-edit { padding-left: 36px; }\n}\n\n@media (max-width: 480px) {\n  .Posts_content-edit { padding: 10px 8px 80px; }\n  .card-body-edit { padding: 10px 12px; }\n  /* floating btn handled in its own block above */\n  .action-btn, .action-btn-edit { padding: 6px 12px; font-size: 12px; }\n  .confirmation-dialog-edit { padding: 22px 20px; }\n}\n/* ======================================\n   CREATE POST MODAL — BEAUTIFIED\n====================================== */\n.create-post-modal-edit {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 20, 40, 0.50);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.create-post-content-edit {\n  background: var(--surface);\n  padding: 0;\n  border-radius: var(--radius-lg);\n  width: 92%;\n  max-width: 540px;\n  max-height: 82vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  animation: modalIn 0.28s var(--ease);\n}\n\n/* Modal header row */\n.modal-header-edit {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px 0;\n}\n\n.modal-title-edit {\n  font-family: var(--font);\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--brand);\n  letter-spacing: -0.2px;\n}\n\n.modal-close-edit {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  background: var(--surface-2);\n  color: var(--text-muted);\n  font-size: 15px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s var(--ease);\n}\n\n.modal-close-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* Tab bar */\n.tabs {\n  display: flex;\n  border-bottom: 1.5px solid var(--border);\n  padding: 0 18px;\n  margin-top: 10px;\n}\n\n.tab-btn-edit {\n  flex: 1;\n  background: none;\n  border: none;\n  padding: 9px 8px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--text-muted);\n  border-bottom: 2.5px solid transparent;\n  margin-bottom: -1.5px;\n  transition: color 0.18s, border-color 0.18s;\n}\n\n.tab-btn-edit.active {\n  border-bottom-color: var(--brand);\n  color: var(--brand);\n}\n\n/* Tab body — reduced padding */\n.tab-content-edit {\n  padding: 14px 18px 16px;\n}\n\n/* Author row inside modal */\n.post-author-row-edit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.post-author-avatar-edit {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border-strong);\n  flex-shrink: 0;\n}\n\n.post-author-name-edit {\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 1px;\n}\n\n.post-author-scope-edit {\n  font-family: var(--font);\n  font-size: 11px;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* Main textarea */\n.post-input-edit {\n  width: 100%;\n  padding: 10px 12px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-primary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  outline: none;\n  resize: none;\n  min-height: 90px;\n  max-height: 220px;\n  line-height: 1.65;\n  background: var(--surface-2);\n  box-sizing: border-box;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n\n.post-input-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background: var(--surface);\n}\n\n.post-input-edit::placeholder {\n  color: var(--text-muted);\n}\n\n/* Char counter */\n.post-char-count-edit {\n  text-align: right;\n  font-family: var(--font);\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n/* Media attachment strip */\n.post-media-strip-edit {\n  display: flex;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 8px;\n  background: var(--surface-2);\n  border-radius: var(--radius-sm);\n  border: 1.5px dashed var(--border-strong);\n}\n\n.media-strip-btn-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  flex: 1;\n  padding: 7px 4px;\n  background: none;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  color: var(--text-muted);\n  font-family: var(--font);\n  font-size: 10.5px;\n  font-weight: 600;\n  transition: background 0.15s, color 0.15s;\n}\n\n.media-strip-btn-edit svg,\n.media-strip-btn-edit span.icon {\n  font-size: 16px;\n}\n\n.media-strip-btn-edit:hover {\n  background: var(--brand-soft);\n  color: var(--brand);\n}\n\n/* Preview images / videos */\n.preview-image {\n  width: 100%;\n  max-height: 220px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  margin-top: 8px;\n}\n\n.preview-video {\n  width: 100%;\n  max-height: 200px;\n  border-radius: var(--radius-sm);\n  margin-top: 8px;\n}\n\n/* Upload zone (image/video tabs) */\n.upload-zone-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 24px 16px;\n  background: var(--surface-2);\n  border: 2px dashed var(--border-strong);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  color: var(--text-muted);\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.upload-zone-edit:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}\n\n.upload-zone-edit .upload-icon {\n  font-size: 28px;\n  opacity: 0.7;\n}\n\n/* Divider */\n.modal-divider-edit {\n  height: 1px;\n  background: var(--border);\n  margin: 12px 0;\n}\n\n/* Footer row */\n.modal-footer-edit {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n/* Emoji / quick tool buttons */\n.quick-tools-edit {\n  display: flex;\n  gap: 4px;\n}\n\n.quick-tool-btn-edit {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1.5px solid var(--border-strong);\n  background: var(--surface-2);\n  color: var(--text-muted);\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s var(--ease);\n}\n\n.quick-tool-btn-edit:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}\n\n/* Post submit button */\n.submit-btn-edit {\n  padding: 9px 24px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.2px;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n  flex-shrink: 0;\n}\n\n.submit-btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px var(--brand-glow-md);\n}\n\n.submit-btn-edit:disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Image / video tab layout */\n.image-tab-edit,\n.video-tab-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Upload message */\n.upload-message {\n  background: var(--brand-soft);\n  color: var(--brand);\n  padding: 10px 14px;\n  border-radius: var(--radius-sm);\n  text-align: center;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid var(--border-strong);\n  margin-bottom: 8px;\n}\n\n/* Emoji picker */\n.emoji-picker-container-edit {\n  position: absolute;\n  bottom: 44px;\n  left: 0;\n  z-index: 1000;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.close-emoji-picker-btn-edit {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: var(--surface-2);\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--text-muted);\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.close-emoji-picker-btn-edit:hover {\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .create-post-content-edit {\n    width: 96%;\n    border-radius: var(--radius-md);\n  }\n  .tab-content-edit {\n    padding: 12px 14px 14px;\n  }\n  .modal-header-edit {\n    padding: 12px 14px 0;\n  }\n  .tabs {\n    padding: 0 14px;\n  }\n  .post-input-edit {\n    font-size: 13px;\n    min-height: 80px;\n  }\n  .submit-btn-edit {\n    padding: 8px 18px;\n    font-size: 12.5px;\n  }\n}\n/* ======================================\n   SKELETON LOADING CARDS\n====================================== */\n.skeleton {\n  background: linear-gradient(90deg, #e8edf5 25%, #f4f6fa 50%, #e8edf5 75%);\n  background-size: 400% 100%;\n  animation: shimmer 1.4s ease-in-out infinite;\n  border-radius: var(--radius-sm);\n}\n\n@keyframes shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.skeleton-card {\n  pointer-events: none;\n  opacity: 0.85;\n}\n\n.skeleton-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.skeleton-line {\n  height: 13px;\n  display: block;\n}\n\n.skeleton-media {\n  width: 100%;\n  height: 200px;\n  border-radius: var(--radius-md);\n  margin-top: 14px;\n}\n\n/* ======================================\n   OWN POST BADGE\n====================================== */\n.own-post-card {\n  border-color: var(--brand-soft);\n  background: linear-gradient(180deg, #fafcff 0%, var(--surface) 100%);\n}\n\n.own-post-badge {\n  font-family: var(--font);\n  font-size: 10.5px;\n  font-weight: 700;\n  color: var(--brand);\n  background: var(--brand-soft);\n  text-align: center;\n  padding: 4px 10px;\n  border-bottom: 1px solid var(--border);\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n}\n\n/* ======================================\n   POST META ROW (date + like count)\n====================================== */\n.post-meta-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 4px 0;\n  margin-bottom: 2px;\n}\n\n.meta-likes {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.meta-time {\n  font-family: var(--font);\n  font-size: 11.5px;\n  color: var(--text-muted);\n}\n\n/* ======================================\n   HEADER RIGHT (follow + options)\n====================================== */\n.header-right-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Following state for follow button */\n.follow-btn-edit.following {\n  background: transparent;\n  color: var(--brand);\n  border: 1.5px solid var(--brand-mid);\n  box-shadow: none;\n}\n\n.follow-btn-edit.following:hover {\n  background: var(--brand-soft);\n  transform: none;\n  box-shadow: none;\n}\n\n/* ======================================\n   ERROR & EMPTY STATES\n====================================== */\n.error-state-edit {\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--danger);\n  font-family: var(--font);\n}\n\n.retry-btn-edit {\n  margin-top: 14px;\n  padding: 9px 28px;\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease);\n}\n.retry-btn-edit:hover { transform: translateY(-2px); }\n\n.empty-state-edit {\n  text-align: center;\n  padding: 56px 24px;\n  color: var(--text-muted);\n  font-family: var(--font);\n  font-size: 14px;\n}\n\n/* ======================================\n   NO COMMENTS TEXT\n====================================== */\n.no-comments-text {\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 12px 0;\n  margin: 0;\n}\n\n/* ======================================\n   FLOATING CREATE POST BUTTON — Enhanced\n====================================== */\n.floating-create-post-btn-edit {\n  position: fixed;\n  bottom: 28px;\n  right: 28px;\n  padding: 13px 26px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 4px 20px var(--brand-glow-md), 0 2px 6px rgba(0,0,0,0.15);\n  letter-spacing: 0.3px;\n  transition: transform 0.22s var(--ease), box-shadow 0.22s var(--ease);\n  z-index: 200;\n}\n\n.floating-create-post-btn-edit:hover {\n  transform: translateY(-3px) scale(1.04);\n  box-shadow: 0 8px 28px var(--brand-glow-md);\n}\n\n/* ======================================\n   MESSAGE POPUP — enhanced\n====================================== */\n.message-popup-edit {\n  position: fixed;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--text-primary);\n  color: white;\n  padding: 10px 22px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  z-index: 1000;\n  box-shadow: var(--shadow-lg);\n  animation: popIn 0.22s var(--ease);\n}\n\n@keyframes popIn {\n  from { opacity: 0; transform: translateX(-50%) translateY(10px) scale(0.95); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }\n}\n\n/* ======================================\n   HIDE REPLY BUTTON\n====================================== */\n.hide-reply-btn-edit {\n  font-family: var(--font);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 100px;\n  transition: all 0.15s;\n}\n\n.hide-reply-btn-edit:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* Reply options container */\n.reply-options-container-edit {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* ======================================\n   FEED ROOT — two-section layout\n====================================== */\n.feed-root {\n  width: 100%;\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 24px 16px 120px;\n  font-family: var(--font);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ======================================\n   FEED SECTION (wrapper for each group)\n====================================== */\n.feed-section {\n  margin-bottom: 40px;\n}\n\n.feed-section--suggested {\n  position: relative;\n}\n\n/* Divider line between the two sections */\n.feed-section--suggested::before {\n  content: '';\n  display: block;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--border-strong) 30%, var(--border-strong) 70%, transparent);\n  margin-bottom: 32px;\n}\n\n/* ======================================\n   SECTION HEADER (title + action row)\n====================================== */\n.feed-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 2.5px solid var(--border);\n  position: relative;\n}\n\n/* left-side accent line on the active section */\n.feed-section-header::after {\n  content: '';\n  position: absolute;\n  bottom: -2.5px;\n  left: 0;\n  width: 48px;\n  height: 2.5px;\n  background: linear-gradient(90deg, var(--brand), var(--brand-light));\n  border-radius: 100px;\n}\n\n.feed-section-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.feed-section-icon {\n  font-size: 22px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.feed-section-title {\n  font-family: var(--font);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n  letter-spacing: -0.3px;\n  line-height: 1.2;\n}\n\n.feed-section-sub {\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   INLINE CREATE-POST BUTTON\n   (sits in the My Posts header row)\n====================================== */\n.create-post-inline-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 20px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.2px;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.create-post-inline-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.create-post-plus {\n  font-size: 18px;\n  line-height: 1;\n  font-weight: 400;\n}\n\n/* ======================================\n   POST LIST — stacked with gap\n====================================== */\n.post-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.skeleton-feed {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ======================================\n   EMPTY STATE — updated with icon\n====================================== */\n.empty-state-edit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 24px;\n  background: var(--surface-2);\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--radius-lg);\n  text-align: center;\n}\n\n.empty-icon {\n  font-size: 36px;\n  line-height: 1;\n}\n\n.empty-state-edit p {\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   OWN POST: remove old badge, keep subtle tint\n====================================== */\n.own-post-card {\n  border-left: 3px solid var(--brand-light);\n}\n\n/* Remove the text badge — section heading already communicates ownership */\n.own-post-badge {\n  display: none;\n}\n\n/* ======================================\n   FLOATING CREATE BUTTON — hide since\n   we now have the inline button.\n   Keep definition in case it's reused.\n====================================== */\n.floating-create-post-btn-edit {\n  display: none;\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 520px) {\n  .feed-root {\n    padding: 16px 10px 100px;\n  }\n\n  .feed-section-title {\n    font-size: 16px;\n  }\n\n  .create-post-inline-btn {\n    padding: 8px 14px;\n    font-size: 12px;\n  }\n\n  .create-post-plus {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
